import { fetch } from '@atlassian/eoc-fetch';

import {
	type AiNotificationPolicy,
	type AiNotificationPolicyResponse,
	type ChangeAiNotificationPolicyOrderParamsWithTeamId,
	type ChangeAiNotificationPolicyStateParamsWithTeamId,
	type CreateAiNotificationPolicyParamsWithTeamId,
	type DeleteAiNotificationPolicyParamsWithTeamId,
	type UpdateAiNotificationPolicyParamsWithTeamId,
} from '../../../../common/types';

export const getGroupNotificationPolicies = (
	teamId: string,
): Promise<AiNotificationPolicyResponse> => {
	return fetch<AiNotificationPolicyResponse>(`/v1/teams/${teamId}/policies?type=aiNotification`);
};

export const changeGroupNotificationPolicyOrderEndpoint = (
	payload: ChangeAiNotificationPolicyOrderParamsWithTeamId,
): Promise<Response> => {
	return fetch(`/v1/teams/${payload.teamId}/policies/${payload.id}/order`, {
		method: 'PATCH',
		body: { after: payload.after },
		responseType: 'headers',
	});
};

export const enableGroupNotificationPolicyEndpoint = (
	payload: ChangeAiNotificationPolicyStateParamsWithTeamId,
): Promise<Response> => {
	return fetch(`/v1/teams/${payload.teamId}/policies/${payload.id}/enable`, {
		method: 'POST',
		responseType: 'headers',
	});
};

export const disableGroupNotificationPolicyEndpoint = (
	payload: ChangeAiNotificationPolicyStateParamsWithTeamId,
): Promise<Response> => {
	return fetch(`/v1/teams/${payload.teamId}/policies/${payload.id}/disable`, {
		method: 'POST',
		responseType: 'headers',
	});
};

export const deleteGroupNotificationPolicyEndpoint = (
	payload: DeleteAiNotificationPolicyParamsWithTeamId,
): Promise<Response> => {
	return fetch(`/v1/teams/${payload.teamId}/policies/${payload.id}`, {
		method: 'DELETE',
		responseType: 'headers',
	});
};

export const createGroupNotificationPolicyEndpoint = (
	payload: CreateAiNotificationPolicyParamsWithTeamId,
): Promise<AiNotificationPolicy> => {
	return fetch<AiNotificationPolicy>(`/v1/teams/${payload.teamId}/policies`, {
		method: 'POST',
		body: payload,
	});
};

export const updateGroupNotificationPolicyEndpoint = (
	payload: UpdateAiNotificationPolicyParamsWithTeamId,
): Promise<AiNotificationPolicy> => {
	return fetch<AiNotificationPolicy>(`/v1/teams/${payload.teamId}/policies/${payload.id}`, {
		method: 'PUT',
		body: payload,
	});
};
